module.exports = __webpack_public_path__ + "static/media/desktopScreenshot02.257e10e1.jpg";